<template>
  <div class="container is-fluid">
    
    <h1 class="title">Add a New Contact Note for {{contact.forename}} {{contact.surname}}</h1>
    <div class="box ">	
      
      
      
      <div class="columns">
        <div class="field column">
          <label class="label">Comments</label>
          <div class="control">
            <textarea class="textarea" rows="2" v-model="contactNote.comments" autofocus></textarea>
          </div>
        </div>
      </div>

      <div class="field is-grouped">
        <p class="control">
          <a class="button is-success" @click.prevent="saveContactNote()" :disabled="saving===1">
            Save
          </a>
         
        </p>
       
      </div>


    </div>
	     

  </div>
</template>

<script>


import ContactService from '@/services/ContactService.js';

import ContactMixin from "@/mixins/ContactMixin.js";

export default {
  components: {
   	
  },
  mixins: [ContactMixin],
  data() {
    return {
      errors: [],
     contactNote: {'comments': '',
        contact_id:this.$route.params.id,
       
      },
       contact: {forename: '', surname: ''},
       saving: 0,
       accessToken: ''
     
    }
  },
  

  // Fetches posts when the component is created.
  created() {
    
     this.getAccessToken()
      .then(() => { 
        this.getContactSingle();
      });
    
   
  },
  methods: {
  	async saveContactNote() {
        this.saving = 1
        ContactService.saveContactNote(this.accessToken, this.contactNote)
        .then(() => { 
          this.$router.push("/contacts/" + this.contactNote.contact_id + '/notes');
          });
        
      }
    }
    
}

</script>

<style>
	
</style>
